import React, { createContext, useEffect, useRef, useState } from 'react'
import '../styles/Profile.scss'
import StarIcon from '@mui/icons-material/Star'
import FeaturedServiceCard from './Cards/FeaturedServiceCard'
import ReviewCard from './Cards/ReviewCard'
import EditPhotosModal from '../modals/EditPhotosModal'
import { Link, useParams } from 'react-router-dom'
import EditIcon from '../assets/imgs/profile-screen-images/edit-icon.svg'
import ChevronRightIcon from '../assets/imgs/profile-screen-images/chevron.png'
import ChevronLeftIcon from '../assets/imgs/profile-screen-images/chevron-right-profile.png'
import ViewAllIcon from '../assets/imgs/profile-screen-images/view-all-icon.svg'
import UserUmagePlaceholder from '../assets/imgs/user-image-placeholder.png'
import { Avatar, Button } from '@mui/material'
import SelectAvailableDateModal from '../modals/SelectAvailableDateModal'
import StarIconPerformance from '../assets/imgs/profile-screen-images/star-icon-performance.png'
import AchievementsIcon from '../assets/imgs/profile-screen-images/achievements.png'
import PostaReviewModal from '../modals/PostaReviewModal'
import ServicesCard from './Cards/ServicesCard'
import TimeIcon from '../assets/imgs/time-icon.svg'
import ServiceTypesModal from '../modals/ServiceTypesModal'
import ServicesModal from './ServicesModal'
import { getDataById } from '../apis/generalApis'
import SelectLocationModal from '../modals/SelectLocationModal'
import { ScaleLoader } from 'react-spinners'

const ProfileContext = createContext({
  profile: {},
  selectedService: {},
})

const Profile = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [userStylistProfile, setUserStylistProfile] = useState(null)
  const [stylistServices, setStylistServices] = useState([])
  const { id } = useParams()
  const [selectLocationModal, setSelectLocationModal] = useState(false)

  useEffect(() => {
    getStylistProfile()
    getScheduledBookings()
    getClientsReviews()
    getStylistServices()
    getPortfolioImages()
  }, [])
  const [stylistScheduledBookings, setStylistScheduledBookings] = useState([])
  const [selectedService, setSelectedService] = useState(null)
  const [clientsReviews, setClientsReviews] = useState([])
  const [userBusinessImages, setUserBusinessImages] = useState([])
  const [serviceAdOnsCost, setServiceAdOnsCost] = useState(0)
  const [serviceTime, setServiceTime] = useState(0)
  const [travelCharges, setTravelCharges] = useState('')
  const [selectedSubCategories, setSelectedSubCategories] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const handleSelectLocationModal = () => {
    setSelectLocationModal(!selectLocationModal)
  }
  const [center, setCenter] = React.useState({
    lat: 48.8584,
    lng: 2.2945,
  })

  const [mapCenter, setMapCenter] = React.useState({
    ...center,
  })
  const [value, setValue] = React.useState(null)
  const [zipCode, setZipCode] = useState('')

  const getClientsReviews = async () => {
    let body = {
      stylist_id: id ? Number(id) : user?.id,
    }
    setIsLoading(true)
    let result = await getDataById('show-stylist-reviews', body)
    setIsLoading(false)
    if (result?.data != null && result?.success === true) {
      setClientsReviews(result?.data?.reverse())
    }
  }

  const getScheduledBookings = async () => {
    let body = {
      stylist_id: id ? Number(id) : user?.id,
    }
    setIsLoading(true)
    let result = await getDataById('show-stylist-schedule-booking', body)
    setIsLoading(false)
    if (result?.success === true && result?.data !== null) {
      setStylistScheduledBookings(result?.data)
    }
  }

  const getStylistProfile = async () => {
    let body = {
      user_id: id ? Number(id) : user?.id,
      viewer_id: user?.id,
    }
    setIsLoading(true)
    let result = await getDataById('show-stylist-profile', body)
    setIsLoading(false)
    if (result?.success === true && result?.data != null) {
      localStorage.setItem('stylist_profile', JSON.stringify(result?.data))
      setUserStylistProfile(result?.data)
    }
  }

  const getStylistServices = async () => {
    let body = {
      stylist_id: id ? Number(id) : user?.id,
    }
    setIsLoading(true)
    let result = await getDataById('stylist-services', body)
    setIsLoading(false)
    if (result?.success === true) {
      setStylistServices(result?.data)
      setSelectedService(result?.data[0])
    }
  }

  useEffect(() => {
    setSelectedSubCategories(selectedService?.category)
  }, [selectedService])

  const getPortfolioImages = async () => {
    let body = {
      user_id: id ? Number(id) : user?.id,
    }
    let result = await getDataById('show-portfolio', body)
    if (result?.data != null) {
      setUserBusinessImages(result?.data)
    }
  }

  const [togglePostaReviewModal, setTogglePostaReviewModal] = React.useState(
    false,
  )
  const [serviceTypeModal, setServiceTypeModal] = useState(false)
  const [servicesModal, setServicesModal] = useState(false)
  const [openEditPhotosModal, setOpenEditPhotosModal] = useState(false)
  const [selectAvailableDateModal, setSelectAvailableDateModal] = useState(
    false,
  )
  const servicesSection = useRef()
  const reviewsSection = useRef()
  const serviceImagesRef = useRef()

  const handlePostaReviewModal = () => {
    setTogglePostaReviewModal(!togglePostaReviewModal)
  }
  const handleEditPhotosModal = () => {
    setOpenEditPhotosModal(!openEditPhotosModal)
  }
  const handleSelectAvailableDateModal = () => {
    setSelectAvailableDateModal(!selectAvailableDateModal)
  }
  const scroll = (scrollValue) => {
    servicesSection.current.scrollLeft += scrollValue
  }
  const scrollReviews = (scrollValue) => {
    reviewsSection.current.scrollLeft += scrollValue
  }
  const scrollServiceImages = (scrollValue) => {
    serviceImagesRef.current.scrollLeft += scrollValue
  }
  const handleServiceTypesModal = () => {
    setServiceTypeModal(!serviceTypeModal)
  }
  const handleServicesModal = () => {
    setServicesModal(!servicesModal)
  }

  const handleServiceAdOn = (category, sub_category, index, ind) => {
    let arr = [...selectedSubCategories]
    let subCatToUpdate = arr[index]?.sub_categories[ind]
    let itemsAddedBeofre = category?.sub_categories?.filter(
      (sub_cat, subInd) => {
        if (
          sub_cat?.hasOwnProperty('is_selected') &&
          sub_cat?.is_selected === true
        ) {
          arr[index].sub_categories[subInd].is_selected = !sub_cat?.is_selected
          return true
        } else if (sub_cat?.id === sub_category?.id) {
          arr[index].sub_categories[subInd].is_selected = true
        }
      },
    )
    setSelectedSubCategories(arr)
  }

  return (
    <>
      {/* <div
      >
      </div> */}
      {/* <Loader backdrop content="loading..." vertical /> */}
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="profile mt-3 position-relative">
        <div className="container position-relative">
          <div className="row">
            <div
              className="col-12 col-sm-12 col-md-8"
              style={{ height: 'calc(100vh - 107px)', overflow: 'auto' }}
            >
              {selectedService?.image?.length > 0 && (
                <div className={`position-relative`}>
                  <img
                    src={ChevronRightIcon}
                    alt="Services Slider Icon"
                    onClick={() => scrollServiceImages(500)}
                    className="service-slider-icon pointer"
                  />
                  <img
                    src={ChevronLeftIcon}
                    alt="Services Slider Icon"
                    onClick={() => scrollServiceImages(-500)}
                    className="service-slider-icon pointer left"
                  />
                  <div
                    className="row flex-nowrap overflow-auto m-0 mt-5 pb-2 position-relative mt-4 g-0"
                    ref={serviceImagesRef}
                    style={{ overflow: 'auto', scrollBehavior: 'smooth' }}
                  >
                    {stylistServices &&
                      stylistServices?.length > 0 &&
                      selectedService?.image?.map((item, index) => (
                        <div
                          className="col-8 col-sm-5 col-md-5 col-lg-5"
                          key={item?.id}
                        >
                          <img
                            src={item}
                            alt=""
                            className="h-100"
                            style={{ borderRadius: '16px', objectFit: 'cover' }}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              )}
              <div className="container p-0">
                <div className="row mt-4">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-9">
                    {!id && (
                      <div className="edit-icon text-right">
                        <Link to={'/profile/editProfile'}>
                          <img
                            src={EditIcon}
                            alt="Edit Icon"
                            style={{ marginRight: '0.5rem', height: '25px' }}
                          />
                        </Link>
                      </div>
                    )}
                    <div className="profile-info-sec d-flex align-items-center w-100">
                      {userStylistProfile?.profile_image && (
                        <Avatar
                          src={userStylistProfile?.profile_image}
                          sx={{ height: 165, width: 165 }}
                        />
                      )}
                      {!userStylistProfile?.profile_image && (
                        <Avatar
                          src={UserUmagePlaceholder}
                          sx={{ height: 165, width: 165 }}
                        />
                      )}
                      {/* <img
                        src={userStylistProfile?.profile_image}
                        height={150}
                        width={165}
                        alt=""
                        className="position-relative"
                        style={{ borderRadius: '50%', objectFit: 'cover' }}
                      /> */}
                      <div
                        className="profile-info-desc text-white px-2 py-1 w-100"
                        style={{ height: '120px' }}
                      >
                        <div className="py-2">
                          <p className="m-0 fs-24 font-weight-bold">
                            {userStylistProfile?.first_name +
                              ' ' +
                              userStylistProfile?.last_name}
                          </p>
                          <p className="m-0 text-capitalize">
                            {userStylistProfile?.title}
                            <span className="mx-2">
                              <StarIcon
                                style={{
                                  fontSize: '20px',
                                  color: '#C9A858',
                                }}
                              />
                            </span>
                            <span>
                              (
                              {Number(userStylistProfile?.avg_rating)?.toFixed(
                                2,
                              )}
                              )
                            </span>
                          </p>
                          <p
                            className="fs-12 m-0"
                            title={userStylistProfile?.about}
                          >
                            {userStylistProfile?.about?.slice(0, 215) ?? ''}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3 d-flex align-items-center justify-content-center flex-column p-0 mt-md-3 mt-lg-0">
                    <h3 className="fs-24 text-black fw-bold">Performance</h3>

                    <div>
                      <p className="fs-16 m-0 d-flex align-items-center justify-content-start">
                        <img
                          src={StarIconPerformance}
                          alt="Star Icon"
                          height={22}
                        />{' '}
                        {userStylistProfile?.positive_reviews}% positive reviews
                      </p>
                      <p className="fs-16 m-0 d-flex align-items-center justify-content-start mt-1">
                        <img
                          src={AchievementsIcon}
                          alt="Achievement Icon"
                          height={22}
                        />
                        {`${
                          userStylistProfile?.completed_jobs ?? 0
                        } completed jobs`}
                      </p>
                      <p className="fs-16 m-0 align-items-center justify-content-start mt-1">
                        <img src={TimeIcon} alt="Clock Icon" height={19} />{' '}
                        {`Joined ${userStylistProfile?.joined ?? ''}`}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-12">
                    <h1 className="m-0 text-black font-weight-bold text-capitalize">
                      {selectedService?.subservice?.name}
                    </h1>
                    <p className="fs-24 m-0">Description</p>
                    <p className="fs-24 m-0">{selectedService?.description}</p>
                  </div>
                </div>
              </div>
              <div>
                <div className="row">
                  <div className="col-12">
                    <h1 className="text-black font-weight-bold mt-5">
                      Services
                    </h1>
                    {stylistServices?.length === 0 && (
                      <h3 className="text-black">No Services found.</h3>
                    )}
                    {stylistServices?.length > 0 && (
                      <div>
                        <div className="position-relative">
                          <img
                            src={ChevronRightIcon}
                            alt="Services Slider Icon"
                            onClick={() => scroll(500)}
                            className="service-slider-icon pointer"
                          />
                          <img
                            src={ChevronLeftIcon}
                            alt="Services Slider Icon"
                            onClick={() => scroll(-500)}
                            className="service-slider-icon pointer left"
                          />
                          <div
                            className="row flex-nowrap overflow-auto m-0 mt-5 pb-2 position-relative mt-4"
                            ref={servicesSection}
                            style={{
                              overflow: 'auto',
                              scrollBehavior: 'smooth',
                            }}
                          >
                            {stylistServices &&
                              stylistServices?.length > 0 &&
                              stylistServices?.map((item, index) => (
                                <div
                                  className="col-10 col-sm-9 col-lg-9 col-xl-6 col-xxl-5 pointer"
                                  key={item?.id}
                                  onClick={() => {
                                    localStorage.setItem(
                                      'selected_service',
                                      JSON.stringify(item),
                                    )
                                    setSelectedService(item)
                                    handleSelectLocationModal()
                                    // handleSelectAvailableDateModal()
                                  }}
                                >
                                  <FeaturedServiceCard service={item} />
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mb-5">
                <div className="reviews row mt-5">
                  <h1 className="text-black fw-bold">Reviews</h1>
                  {clientsReviews.length === 0 && (
                    <h3 className="text-black">No reviews found.</h3>
                  )}
                  {clientsReviews.length > 0 && (
                    <div className="position-relative">
                      <img
                        src={ChevronRightIcon}
                        alt="Services Slider Icon"
                        onClick={() => scrollReviews(500)}
                        className="service-slider-icon pointer"
                      />
                      <img
                        src={ChevronLeftIcon}
                        alt="Services Slider Icon"
                        onClick={() => scrollReviews(-500)}
                        className="service-slider-icon pointer left"
                      />
                      <div
                        className="row flex-nowrap overflow-auto m-0 mt-5 pb-2 position-relative mt-4"
                        ref={reviewsSection}
                        style={{ overflow: 'auto', scrollBehavior: 'smooth' }}
                      >
                        {clientsReviews &&
                          clientsReviews?.length > 0 &&
                          clientsReviews?.map((item, index) => (
                            <div
                              className="col-10 col-sm-9 col-lg-9 col-xl-6 col-xxl-5"
                              key={item?.id}
                            >
                              <ReviewCard review={item} />
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                  {/* {user?.user_type === 'client' && (
                    <div className="col-12 mt-5 text-center">
                      <Button
                        disableElevation
                        className="px-5 pointer"
                        id="btn-primary-no-shadow"
                        onClick={handlePostaReviewModal}
                      >
                        Post a Review
                      </Button>
                    </div>
                  )} */}
                </div>
              </div>
            </div>
            <div
              className="col-12 col-sm-12 col-md-4 p-0"
              style={{ height: 'calc(100vh - 107px)', overflow: 'auto' }}
            >
              {user?.user_type !== 'client' ? (
                <div className="px-3 center d-none d-md-block container">
                  <div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fs-20 fw-bold">
                        What's on the schedule?
                      </span>
                      <span className="fs-12 color-primary fw-bold">
                        See Calendar
                      </span>
                    </div>
                    <div className="row overflow-auto m-0 mt-1 gx-0 gy-2 pb-2">
                      {stylistScheduledBookings?.length > 0 &&
                        stylistScheduledBookings?.map((booking, index) => (
                          <div
                            className="col-10 col-sm-10 col-md-11 col-lg-11 w-100"
                            key={booking?.id}
                          >
                            {/* <Link
                              to={'/styles'}
                              className="text-black text-decoration-none"
                            > */}
                            <ServicesCard
                              booking={booking}
                              component={'profile'}
                              getScheduledBookings={getScheduledBookings}
                            />
                            {/* </Link> */}
                          </div>
                        ))}
                      {/* <div className="col-10 col-sm-10 col-md-11 col-lg-11">
                        <Link
                          to={'/styles'}
                          className="text-black text-decoration-none"
                        >
                          <ServicesCard jobTitle="Hair cut" />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="px-3 center d-none d-md-block container">
                  <div>
                    <div className="row">
                      <div className="col-12">
                        <div className="d-flex align-items-center flex-nowrap overflow-auto gap-4">
                          {stylistServices?.map((service, index) => (
                            <div>
                              {selectedService?.id !== service.id && (
                                <p
                                  style={{
                                    fontSize: '21px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    width: 'max-content',
                                  }}
                                  className="text-capitalize"
                                  onClick={() => setSelectedService(service)}
                                >
                                  {service?.subservice?.name}
                                </p>
                              )}
                              {selectedService?.id === service.id && (
                                <Button
                                  fullWidth
                                  disableElevation
                                  id="btn-filled-primary"
                                  className="text-black text-capitalize"
                                  style={{
                                    borderRadius: '22px',
                                    fontSize: '21px',
                                    fontWeight: 'bold',
                                    padding: '1rem 2rem',
                                    width: 'max-content',
                                  }}
                                  onClick={() => setSelectedService(service)}
                                >
                                  {service?.subservice?.name}
                                </Button>
                              )}
                            </div>
                          ))}
                        </div>
                        {selectedService && (
                          <div className="row mt-3">
                            <div className="col-md-12 col-lg-4">
                              <p className="fs-15">Style Price</p>
                              <p
                                className="color-primary fw-bold"
                                style={{ fontSize: '21px' }}
                              >
                                ${selectedService?.base_price}
                              </p>
                            </div>
                            <div className="col-md-12 col-lg-4 text-center">
                              <p className="fs-15">Est Time</p>
                              <p
                                className="color-primary fw-bold"
                                style={{
                                  fontSize: '21px',
                                  width: 'max-content',
                                }}
                              >
                                {selectedService?.base_time} mins
                              </p>
                            </div>
                            <div className="col-md-12 col-lg-4 text-end">
                              <p className="fs-15">Travel Fee</p>
                              <p
                                className="color-primary fw-bold"
                                style={{ fontSize: '21px' }}
                              >
                                ${user?.travel_charges}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {selectedService?.category?.map((cat, index) => (
                      <div key={cat.id}>
                        <p className="fs-18 fw-bold text-center mt-3 mb-2">
                          Select {cat?.name}
                        </p>
                        <div className="row justify-content-center">
                          {cat?.sub_categories?.map((item, ind) => (
                            <div className="col-md-12 col-lg-4" key={item.id}>
                              <Button
                                className={`${
                                  selectedSubCategories?.length > 0 &&
                                  selectedSubCategories[index]?.sub_categories[
                                    ind
                                  ]?.is_selected
                                    ? 'bg-primary-btn'
                                    : 'transparent text-capitalize'
                                }`}
                                fullWidth
                                disableElevation
                                onClick={
                                  () => handleServiceAdOn(cat, item, index, ind)
                                  //   {
                                  //   let itemIndex = selectedSubCategories?.findIndex(
                                  //     (el) => el?.id === item?.id,
                                  //   )
                                  //   if (itemIndex == -1) {
                                  //     setSelectedSubCategories((prev) => [
                                  //       ...prev,
                                  //       item,
                                  //     ])
                                  //   } else {
                                  //     let arr = [...selectedSubCategories]
                                  //     arr?.splice(itemIndex, 1)
                                  //     setSelectedSubCategories(arr)
                                  //   }
                                  // }
                                }
                              >
                                {item?.name}
                              </Button>
                              <div className="d-flex justify-content-between align-items-center mt-1">
                                <span className="fs-15 color-primary">
                                  +${item?.price}
                                </span>
                                <span className="fs-15 color-primary">
                                  +{item?.time} min
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                    {selectedService && (
                      <div className="text-center mt-3">
                        <Button
                          id="btn-primary"
                          disableElevation
                          className="w-75 mt-3 text-capitalize"
                          onClick={() => {
                            if (selectedSubCategories?.length > 0) {
                              let cost = 0,
                                serviceAdOnsTime = 0
                              selectedSubCategories?.forEach((subCategory) => {
                                subCategory?.sub_categories?.forEach(
                                  (sub_cat) => {
                                    if (
                                      sub_cat?.hasOwnProperty('is_selected') &&
                                      sub_cat?.hasOwnProperty('is_selected') ===
                                        true
                                    ) {
                                      cost += sub_cat?.price
                                      serviceAdOnsTime += sub_cat?.time
                                    }
                                  },
                                )
                              })
                              setServiceTime(serviceAdOnsTime)
                              setServiceAdOnsCost(cost)
                            }
                            handleSelectLocationModal()
                          }}
                        >
                          Book Now
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <EditPhotosModal
        openEditPhotosModal={openEditPhotosModal}
        handleEditPhotosModal={handleEditPhotosModal}
        userPortfolio={userBusinessImages}
        getPortfolioImages={getPortfolioImages}
        isLoggedInUser={id ? false : true}
      />
      <SelectAvailableDateModal
        handleSelectAvailableDateModal={handleSelectAvailableDateModal}
        modalOpen={selectAvailableDateModal}
        screenName="profile-screen-view-all"
        selectedSubService={selectedService}
        stylist={userStylistProfile}
      />
      <PostaReviewModal
        handlePostaReviewModal={handlePostaReviewModal}
        togglePostaReviewModal={togglePostaReviewModal}
        userType="client"
        service={selectedService}
        body={{
          stylist_id: id ? id : user?.id,
          user_id: id ? user?.id : id,
          service_id: selectedService?.id,
        }}
        getClientsReviews={getClientsReviews}
      />
      <ServiceTypesModal
        handleServiceTypesModal={handleServiceTypesModal}
        modalOpen={serviceTypeModal}
        screenName="client-profile"
      />
      <ServicesModal
        handleServicesModal={handleServicesModal}
        modalOpen={servicesModal}
        screenName="client-profile"
      />
      <SelectLocationModal
        handleSelectLocationModal={handleSelectLocationModal}
        selectLocationModal={selectLocationModal}
        mapCenter={mapCenter}
        setCenter={setCenter}
        value={value}
        setValue={setValue}
        setZipCode={setZipCode}
        action="open-select-available-date-modal"
        selectedService={{
          ...selectedService,
          price: serviceAdOnsCost
            ? serviceAdOnsCost + selectedService?.base_price
            : selectedService?.base_price,
          provider: userStylistProfile,
          time: selectedService?.base_time + Number(serviceTime),
        }}
      />
    </>
  )
}

export default Profile
export { ProfileContext }
